import type { RuntimeServices } from '../runtimeServices.types';

/**
 * Creates a new runtime services instance that manages service registration and retrieval.
 *
 * @returns A RuntimeServices object with methods to get, register, and unregister services
 */
export const createRuntimeServices = (): RuntimeServices => {
  const registry = new Map<string, unknown>();

  return {
    getByKey: <T>(key: string) => registry.get(key) as T | null,
    register: (key: string, service: unknown) => registry.set(key, service),
    unregister: (key: string) => registry.delete(key),
  };
};
